<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card class="my-5">
          <v-card-title>
            <v-spacer />
            <!-- Commented out as iframe has built-in download functionality -->
            <!-- <v-btn small color="secondary">
              <v-icon left>mdi-download</v-icon>
              Download
            </v-btn> -->
          </v-card-title>

          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <v-card-text
            v-if="document"
            class="pa-0"
            style="height: 80vh; min-height: 700px; position: relative; background: #525659"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div v-if="isMobile" class="pa-12 text-center d-flex flex-column align-center justify-center">
                <v-icon size="100" color="primary lighten-4">mdi-file-pdf-box</v-icon>
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Document Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your document is ready. Since you are on a mobile device, please use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Document
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrl"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="Document Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </v-card-text>
          <v-card-text v-else class="pa-4">
            <v-skeleton-loader type="image" height="700px" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PdfViewerMixin from "../../../mixins/PdfViewerMixin";

export default {
  name: "SubscriptionDocument",
  mixins: [PdfViewerMixin],
  watch: {
    document: {
      handler(val) {
        if (val) {
          const base64Data = val.includes("base64,")
            ? val.split("base64,")[1]
            : val;
          this.generatePdfUrl(base64Data);
        }
      },
      immediate: true,
    },
  },
  computed: {
    document() {
      return "data:application/pdf;base64,JVBERi0xLjcNCiW1tbW1DQoxIDAgb2JqDQo8PC9UeXBlL0NhdGFsb2cvUGFnZXMgMiAwIFIvTGFuZyhlbi1VUykgL1N0cnVjdFRyZWVSb290IDE3IDAgUi9NYXJrSW5mbzw8L01hcmtlZCB0cnVlPj4vTWV0YWRhdGEgMzkgMCBSL1ZpZXdlclByZWZlcmVuY2VzIDQwIDAgUj4+DQplbmRvYmoNCjIgMCBvYmoNCjw8L1R5cGUvUGFnZXMvQ291bnQgMi9LaWRzWyAzIDAgUiAxMyAwIFJdID4+DQplbmRvYmoNCjMgMCBvYmoNCjw8L1R5cGUvUGFnZS9QYXJlbnQgMiAwIFIvUmVzb3VyY2VzPDwvRm9udDw8L0YxIDUgMCBSL0YyIDkgMCBSL0YzIDExIDAgUj4+L0V4dEdTdGF0ZTw8L0dTNyA3IDAgUi9HUzggOCAwIFI+Pi9Qcm9jU2V0Wy9QREYvVGV4dC9JbWFnZUIvSW1hZ2VDL0ltYWdlSV0gPj4vTWVkaWFCb3hbIDAgMCA2MTIgNzkyXSAvQ29udGVudHMgNCAwIFIvR3JvdXA8PC9UeXBlL0dyb3VwL1MvVHJhbnNwYXJlbmN5L0NTL0RldmljZVJHQj4+L1RhYnMvUy9TdHJ1Y3RQYXJlbnRzIDA+Pg0KZW5kb2JqDQo0IDAgb2JqDQo8PC9GaWx0ZXIvRmxhdGVEZWNvZGUvTGVuZ3RoIDE4MTA+Pg0Kc3RyZWFtDQp4nLVZS2/bOBC+G/B/4G3TomUlkXoBRYE07RZdbDfZxkAPwR5ombbVyJIrySmyv35nhgplO7bVptweWMl8zIPfzDejsFdX7PXrV58uPr5j3ps37O27C/ZtPPK4h/9SP2Aei2CM04DVejz68pyV49HbyXj06nefwcRkPh75sMhjPosD7gWSxV7CY5hZwaIP1zFbNHAgW9Bb0r19GI9uziaXV8/+YZM/xqP3cODf49GTJacxT+WOZBLYyXnpSIrvBTyIjkl5d/nlL1eCpM9FckwQcyYl5PKIOexld6aXhpJNspuz86urz+cfr8//ZFefLy/eX1870iJIwFbxg7ay958uGNvCrN9h1uNpkuC+DoNREvAoYjIKeQyGcj8iTebPD5wR/CTugyO4jxLwZ2cC98GmxcMDOhSeAnLkZKlZW62f5r5Hsn0/BuGnZT85Ah5LC3wItCFps+rZy/TsOw4lDgyHNQ66xnGOA62pVzgquzKjRXaPshvXtX3PcWjsa0Er6Rzd4ri0p8/sQf0ecy6NtLo/l1bnrV1eWa06OSur3FE5UxzumTV/aU8jy5Z7cH4AThRziDIRR9wTiFZPWrT+Mihjj4tBTCq2UqVawPX43hnLG9Yu8UmzpirMg75TxUa1+FLVrJozfFrCSo0Pq3VR3WvdsG7+aXAD2320fdsMkXg8ESfNuMGbBbkb8H6MN5LgrQq8lgSdH56VCmfg1nwJF+hMNylSDIMh3dzJk5Ki76Q87ijUpUy4Fw0IG0rPwlVqlTH35ZPVkJ0aD6cFSBdMhnBoOMQOoSsTAsHj4yZ8dHRtkEOCIWl93JdMOeWihItBS91xkUBMDEib2Sy9x0dqbcnFcMA+r+Dwwi43Kb+npj3ioqeFtqf19FX27KDtxrWVQKrd06zeFXZvF+bZrlZFzzI9J/XE1DNeucW8VrWmJ7cjdOSFPIHaSULk74fHL0cBlHnRcI3UVnDiXU7c8h3ISBOxaKIZetK/NWyt67nhGyCvjH7m7Bz/X69rlTeqaIjOqrkjxCEXBeK0DTfmDnTv/unu5amjhQ7brUfKxe6aypZOh68tTD1USwrBRer42sJUYEMydG3V9KvO2vyO7o2pcsboBjb4Mz7gFFYS+IzVRF6VtDKr85b2UP2RK84u5+aH8gXePi2iCoVuuWbzqigqAkcDGeywO+IQVZbQSnn7LcAvuyNOjtNR74=";
    },
  },
};
</script>

<style scoped>
iframe {
  border: none;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>